import SmallestPrice from './SmallestPrice';

export default SmallestPrice;
